<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'UsuariosComponent',
  data: () => ({})
}
</script>